export default class AutoStowageRuleApi {
    getAutoStowageRule() {
        return this.GET("order/autoStowageRule/get");
    }

    getAutoStowageRuleList() {
        return this.GET("order/autoStowageRule/list");
    }

    saveAutoStowageRule(params) {
        return this.POST("order/autoStowageRule/save", params);
    }

    updateAutoStowageRuleStatus(params) {
        return this.POST(`order/autoStowageRule/status/${params.id}/${params.status}`, params);
    }
}
